<script>
import { cloneDeep } from "lodash";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import Multiselect from "vue-multiselect";
import PrintOptions from "@/components/modals/print-options.vue";
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    // MaskedInput,
    // Multiselect,
    // ProcessSubtype,
    // ManageDu,
    // RawData,
    // PrintOptions,
    // ProcessStep,
    // Carousel,
    // Slide,
  },
  data() {
    return {
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false,
      }),
      submitted: false,
      modalTitle: "",
      tableData: [],
      slideNum: 1,
      reportList: false,
      dus: [],
      loading: false,
      selectedDU: null,
    };
  },
  methods: {
    addProcessType(du) {
        this.selectedDU = du;
        this.$refs.modalCreateProcessType.onReset();
        this.modalTitle = "Create Process Type";
        this.$bvModal.show("process-type-modal");
    },
    printProcessType(type) {
        if(type){
            this.$refs.printOpt.putOptions({
            apiUrl: "dts/api/Report/ProcessType/Owner",
            routeVariables: [this.form.processOwnerId],
            });
        }else{
            this.$refs.printOpt.putOptions({
            apiUrl: "dts/api/Report/ProcessType",
            routeVariables: [],
            });
        }
        this.$bvModal.show("print-options-modal");
    },
    goToSelection() {
      this.slideNum = 2;
    },
    goBackToSelection() {
      this.slideNum = 1;
    },
    async getDus(id){
      this.loading = true;
      this.dus = [];
      await this.$store.dispatch("deliveryunit/GetDeliveryUnitByCampus", id).then((res) => {
        if (res.data.error) {
          return this.showToast(res.data.errorMessage, "error");
        }
        res.data.map(item => {
            item.showProcesses = false;
            item.loadProcesses = false;
            item.processes = [];
        })
        this.dus = res.data;
      }).catch((err) => {
        this.showToast("Cannot be deleted!", "error");
      });
      this.loading = false;
    },
    async showProcesses(item){
      item.showProcesses = !item.showProcesses;
      if(item.showProcesses){
        item.loadProcesses = true;
        await this.getProcessesByDU(item);
        item.loadProcesses = false;
      }
    },
    async getProcessesByDU(item){
        await this.$store.dispatch("dtsprocesstype/GetDUByProcessType", item.id).then((res) => {
            if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
            }
            item.processes = res.data;
        }).catch((err) => {
            this.showToast("Cannot be deleted!", "error");
        });
    }
  },
//   async created(){
//     await this.getDus(this.$store.state.data.selectedCampus.id);
//   }
}
</script>
<template>
    <div>
        <div class="d-flex align-items-center justify-content-between mb-2">
            <h5 class="mb-0">List of Delivery Unit Processes</h5>
            
        </div>
        <div>
            <div class="mb-3 d-flex justify-content-between">
                <div class="w-25">
                    <input type="text" class="form-control" placeholder="Search Delivery Unit" >
                </div>
                <div class="d-flex">
                    <button
                        type="button"
                        class="btn btn-sm btn-purple d-flex align-items-center me-1"
                        :id="`select-report`"
                        @click="reportList = true"
                        >
                        <i class="bx bx-printer fs-6 me-1"></i>Print Process Types
                    </button>
                    <!-- <b-popover
                        :target="`select-report`"
                        triggers="click"
                        placement="left"
                        :show.sync="reportList"
                        custom-class="popover-report"
                    >
                    <template v-slot:title>
                        <div
                            class="
                                d-flex
                                align-items-center
                                justify-content-between
                            "
                        >
                            <small>Print Process Types</small>
                            <span
                                class="
                                    bx bx-x
                                    font-size-14
                                    cursor-pointer
                                "
                                @click="reportList = false"
                            ></span>
                        </div>
                    </template>
                    <carousel
                        ref="carousel"
                        class="
                            events
                            navs-carousel
                            custom-carousel
                        "
                        id="timeline-carousel"
                        :navigation-enabled="false"
                        :pagination-enabled="false"
                        :perPage="1"
                        :autoplay="false"
                        :minSwipeDistance="0"
                        :mouseDrag="false"
                    >
                        <slide>
                            <div v-if="slideNum == 1">
                            <div>
                                <a
                                    href="javascript:void(0);"
                                    @click="printProcessType"
                                    class="
                                    font-size-12
                                    text-dark
                                    hoverable-link
                                    "
                                    >All</a
                                >
                            </div>
                            <hr class="my-1" />
                            <div>
                                <a
                                    href="javascript:void(0);"
                                    @click="goToSelection"
                                    class="
                                        font-size-12
                                        text-dark
                                        hoverable-link
                                    "
                                    >By Owner</a
                                >
                            </div>
                            </div>
                        </slide>
                        <slide>
                            <div v-if="slideNum == 2">
                            <a
                                href="javascript:void(0);"
                                class="
                                text-primary
                                d-flex
                                align-items-center
                                "
                                @click="goBackToSelection"
                                ><i
                                    class="
                                    bx bx-left-arrow-alt
                                    me-1
                                    "
                                ></i
                                >Go back to selection</a
                            >
                            <div class="mb-3 mt-2">
                                <label for="campus" class="mb-1">Campus</label>
                                <select
                                id="campus"
                                v-model="form.campusId"
                                class="form-control form-select"
                                @change="getDus"
                                >
                                <option value="0"></option>
                                <option
                                    v-for="(campus, index) in campuses"
                                    :key="index"
                                    :value="campus.id"
                                    >{{ campus.campusName}}</option
                                >
                                </select>
                            </div>
                            <b-collapse :visible="form.campusId != 0">
                                <div v-if="form.campusId != 0">
                                <div class="mb-3">
                                    <label for="office">Process Owner</label>
                                    <select
                                    id="office"
                                    v-model="form.processOwnerId"
                                    class="form-control form-select"
                                    :class="{
                                        'is-invalid': submitted && $v.form.processOwnerId.$error,
                                    }"
                                    >
                                    <option value="0"></option>
                                    <option
                                        v-for="(du, index) in dus"
                                        :key="index"
                                        :value="du.id"
                                        >{{ du.name }}</option
                                    >
                                    </select>
                                    <div
                                    v-if="submitted && $v.form.processOwnerId.$error"
                                    class="invalid-feedback"
                                    >
                                    <span v-if="!$v.form.processOwnerId.required"
                                        >This value is required.</span
                                    >
                                    </div>
                                </div>
                                </div>
                            </b-collapse>
                            <div class="d-flex">
                                <button type="submit" class="btn btn-sm btn-block btn-purple" @click="printProcessType('du')">Print Report</button>
                            </div>
                            </div>
                        </slide>
                    </carousel>
                    </b-popover> -->
                </div>
            </div>
            <ul>
                <li class="w-100 mb-2" v-for="x in dus" :key="x.id">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                            <a href="javascript:void(0);" class="font-size-18 text-dark" @click="showProcesses(x)">
                                <span 
                                    :class="{
                                        'text-yellow': x.showProcesses,
                                        'text-white': !x.showProcesses,
                                    }"
                                > 
                                    {{ x.name }} 
                                </span>
                                <i class="bx bx-caret-right rotate" 
                                    :class="{
                                        'rotate-90 text-yellow': x.showProcesses,
                                        'text-white': !x.showProcesses,
                                    }">
                                </i>
                            </a> 
                            <div v-if="x.showProcesses" class="ms-2">
                                <button type="button" class="btn btn-xs btn-primary" @click="addProcessType(x)"><i class="bx bx-plus"></i> Add New Process</button>
                            </div>
                        </div>
                    </div>
                    <b-collapse
                        :visible="x.showProcesses"
                        :accordion="`du-accordion-${x.id}`"
                        role="tabpanel"
                    >
                        <div class="pt-2" v-if="x.showProcesses">
                            <div
                                class="p-3 d-flex align-items-center"
                                v-if="x.loadProcesses"
                            >
                                <div class="preloader-component me-2">
                                <div class="status">
                                    <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    </div>
                                </div>
                                </div>
                                <h5 class="mb-0">Loading...</h5>
                            </div>
                            <div v-else class="position-relative">
                                <template v-if="x.processes.length">
                                </template>
                                <template v-else>
                                    <div class="px-3">
                                        <h5 class="mb-0 text-secondary">No processes found.</h5>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </b-collapse>
                </li>
            </ul>
        </div>
    </div>
</template>